import { render, staticRenderFns } from "./addDictModal.vue?vue&type=template&id=cb0e035c&scoped=true"
import script from "./addDictModal.vue?vue&type=script&lang=js"
export * from "./addDictModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0e035c",
  null
  
)

export default component.exports